import React from 'react';
import AddEditCustomerForm from 'ui-component/AddEditCustomerForm';
import AddEditContactForm from 'ui-component/contact/AddEditContactForm';


function AddContact() {
  return (
    <div>
      <AddEditContactForm title="Add Contact" />
    </div>
  );
}

export default AddContact;
